import { useMemo } from 'react';
import useAddGroupSupporter from '@pkg/api/designs/mutations/useAddGroupSupporter';
import useRemoveGroupSupporter from '@pkg/api/designs/mutations/useRemoveGroupSupporter';

/**
 * The writes for one group, bound to its whole ids so only the user is named.
 * Each write refreshes the reads it changed by their own paths, so nothing else
 * is threaded through from the caller.
 *
 * @param {String} designId
 * @param {String} groupId
 * @return {Object}
 */
export default function useSupporterMutations(designId, groupId) {
  const add = useAddGroupSupporter();
  const remove = useRemoveGroupSupporter();

  return useMemo(
    () => ({
      add: (userId) => add(designId, groupId, userId),
      remove: (userId) => remove(designId, groupId, userId),
    }),
    [add, remove, designId, groupId]
  );
}
